import React, { Component } from "react";
import { Popover } from "../../actions/Tippy";
import Moment, { diff } from "moment";
import TimeCounterMinute from "../../containers/TimeCounterMinute";
import { Topover } from "../../actions/Tippy";
import DEFAULT from "../../build/images/default.png";

import CLIENTE from "../../build/images/cliente.svg";
import FACEBOOK from "../../build/images/facebook_new.svg";
import WHATSAPP from "../../build/images/whatsapp_new.svg";
import TELEGRAM from "../../build/images/telegram-new.svg";
import PHONE from "../../build/images/callchat-new.svg";
import WEBCHAT from "../../build/images/webchat-new.svg";
import INSTAGRAM from "../../build/images/instagram_new.svg";

import _ from "lodash";
const { connection_platform } = require("../../services/api");

var ipcurrent = "";
var gethostname = window.location.hostname;
var pathname = "";
var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

class QueueItem extends Component {
  renderPopoverInfo2 = (e, info) => (
    <div className="context-menu" id="qtd-retorno">
      {(() => {
        if (info) {
          let array = info.split(";");
          array.pop();
          return (
            <ul className="context-menu__list">
              {array.map((todo) => {
                let position = todo.split("-");
                return (
                  <li className="context-menu__item">
                    <div className="container-tippy-return">
                      <div className="tippyTxt">
                        {position[2] ? position[1] : position[0]}
                      </div>

                      <div className="item-tippy-return">
                        <i className="material-icons">date_range</i>{" "}
                        {position[2] ? position[0] : ""}
                      </div>

                      <div className="info-return">
                        <span>Motivo: </span>
                        {position[2] ? position[2] : position[1]}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          );
        }
      })()}
    </div>
  );

  renderPopoverInfo = (e, ip, file) => (
    <>
      {file ? (
        <div className="img">
          <img
            src={
              file ? connection_platform.type_connect + "://" + ip + file : null
            }
            width="100"
            alt=""
          />
        </div>
      ) : (
        ""
      )}
    </>
  );

  render() {
    const {
      queue,
      IPCurrent,
      InfoUsers,
      SolicitarChamadaAtiva,
      SolicitarChamada,
      PermissionRouter,
      StatusAgent,
      AtdSimult,
      OutBandService,
      renderPopover,
      buttonDetails,
      expandQueue,
      checkExpandQueue,
    } = this.props;
    return (
      <div className="item item--border-bottom">
        <div
          className="img"
          onClick={(event) => checkExpandQueue(event, queue.queueid)}
        >
          {(() => {
            if (
              queue.pathfile === "  " ||
              queue.pathfile === " " ||
              queue.pathfile === null
            ) {
              return <img src={DEFAULT} alt="" />;
            } else {
              return (
                <Topover
                  interactive={true}
                  content={this.renderPopoverInfo(
                    this,
                    ipcurrent,
                    queue.pathfile
                  )}
                >
                  <img
                    src={
                      queue.pathfile
                        ? connection_platform.type_connect +
                          "://" +
                          ipcurrent +
                          queue.pathfile
                        : null
                    }
                    alt=""
                  />
                </Topover>
              );
            }
          })()}
        </div>
        <div className="inner">
          <div className="title">
            <div className="about-user">
              <div
                className="nome"
                id={queue.queueid}
                onClick={(event) => checkExpandQueue(event, queue.queueid)}
              >
                {(() => {
                  switch (parseInt(queue.mediaid)) {
                    case 1:
                      return (
                        <img
                          className="prox-atend__enqueued-icon"
                          src={PHONE}
                          style={{ width: 16 }}
                          alt=""
                        />
                      );
                    case 2:
                      return (
                        <img
                          className="prox-atend__enqueued-icon"
                          src={WEBCHAT}
                          style={{ width: 16 }}
                          alt=""
                        />
                      );
                    case 3:
                      return (
                        <img
                          className="prox-atend__enqueued-icon"
                          src={WEBCHAT}
                          style={{ width: 16 }}
                          alt=""
                        />
                      );
                    case 4:
                      return (
                        <img
                          className="prox-atend__enqueued-icon"
                          src={FACEBOOK}
                          style={{ width: 16 }}
                          alt=""
                        />
                      );
                    case 5:
                      return (
                        <img
                          className="prox-atend__enqueued-icon"
                          src={WHATSAPP}
                          style={{ width: 16 }}
                          alt=""
                        />
                      );
                    case 6:
                      return (
                        <img
                          className="prox-atend__enqueued-icon"
                          src={INSTAGRAM}
                          style={{ width: 16 }}
                          alt=""
                        />
                      );
                    case 8:
                      return (
                        <img
                          className="prox-atend__enqueued-icon"
                          src={TELEGRAM}
                          style={{ width: 16 }}
                          alt=""
                        />
                      );
                    default:
                      break;
                  }
                })()}
                {/* {_.upperFirst(queue.caller)} */}
                <span
                  className="nome__text is-poppins"
                  onClick={(event) => checkExpandQueue(event, queue.queueid)}
                >
                  {(() => {
                    if (queue.contactname) {
                      if (queue.contactname !== " ") {
                        var mensagem_tratada = queue.contactname;
                        let valor = 1;
                        try {
                          mensagem_tratada =
                            '{"' +
                            valor +
                            '": [{"mensagem_tratada":"' +
                            mensagem_tratada +
                            '"}]}';
                          var obj = JSON.parse(mensagem_tratada);
                          mensagem_tratada = obj[1][0].mensagem_tratada;
                        } catch (e) {
                          mensagem_tratada = queue.contactname;
                        }
                        return mensagem_tratada;
                      } else {
                        return _.upperFirst(queue.caller);
                      }
                    } else {
                      return _.upperFirst(queue.caller);
                    }
                  })()}
                </span>
              </div>
              <div className="criticidade normal" data-tippy="Normal">
                •
              </div>
            </div>
            <div className="title__top">
              {(() => {
                var now;
                var antes;
                var duracao = 0;
                var checkItem = false;

                if (IPCurrent.difftime < 0) {
                  antes = Moment(queue.to_char, "DD/MM/YYYY HH:mm:ss").format(
                    "YYYY/MM/DD HH:mm:ss"
                  );
                  now = Moment()
                    .add(Math.round(IPCurrent.difftime), "seconds")
                    .format("YYYY/MM/DD HH:mm:ss");
                  duracao = Moment(now).diff(antes, "seconds");
                  checkItem = true;
                } else {
                  antes = Moment(queue.to_char, "DD/MM/YYYY HH:mm:ss").format(
                    "YYYY/MM/DD HH:mm:ss"
                  );
                  now = Moment()
                    .subtract(Math.round(IPCurrent.difftime), "seconds")
                    .format("YYYY/MM/DD HH:mm:ss");
                  duracao = Moment(now).diff(antes, "seconds");
                  checkItem = true;
                }

                var days = Moment(now).diff(antes, "days");

                return (
                  <div
                    className={
                      parseInt(queue.status) === 1 && checkItem === true
                        ? "user-time active"
                        : "user-time"
                    }
                    onClick={(event) => checkExpandQueue(event, queue.queueid)}
                  >
                    <i className="material-icons">query_builder</i>{" "}
                    <span className="time">
                      <TimeCounterMinute
                        horario={duracao < 0 ? 0 : parseInt(duracao)}
                        day={days}
                        key={queue.queueid}
                      />{" "}
                    </span>
                  </div>
                );
              })()}
              <div
                className={
                  parseInt(queue.status) !== 1
                    ? "user-date active"
                    : "user-date"
                }
                onClick={(event) => checkExpandQueue(event, queue.queueid)}
              >
                <i className="material-icons">date_range</i>{" "}
                <span className="date">
                  {Moment(queue.to_char, "DD/MM/YYYY HH:mm:ss").format(
                    "DD/MM/YYYY HH:mm"
                  )}
                </span>
              </div>
              <div className="actions">
                {(() => {
                  switch (parseInt(queue.status)) {
                    case 0:
                      return (
                        <a
                          data-tippy="Atender chamada"
                          className="phone"
                          onClick={(event) =>
                            SolicitarChamadaAtiva(
                              event,
                              PermissionRouter,
                              queue.mediaid,
                              StatusAgent.status,
                              InfoUsers,
                              queue.caller,
                              OutBandService,
                              queue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent
                            )
                          }
                        >
                          <i className="material-icons">call</i>
                          <input
                            type="hidden"
                            id={"clickqueue_" + queue.queueid}
                            name={"clickqueue_" + queue.queueid}
                          />
                        </a>
                      );
                    case 1:
                      return (
                        <a
                          data-tippy="Atender chamada"
                          className="phone"
                          onClick={() =>
                            SolicitarChamada(
                              InfoUsers,
                              queue.scriptid,
                              queue.cdrid,
                              queue.mediaid,
                              StatusAgent.status,
                              StatusAgent
                            )
                          }
                        >
                          <i className="material-icons">call</i>
                        </a>
                      );
                    default:
                      return (
                        <a
                          data-tippy="Atender chamada"
                          className="phone"
                          onClick={(event) =>
                            SolicitarChamadaAtiva(
                              event,
                              PermissionRouter,
                              queue.mediaid,
                              StatusAgent.status,
                              InfoUsers,
                              queue.caller,
                              OutBandService,
                              queue,
                              AtdSimult,
                              IPCurrent,
                              StatusAgent
                            )
                          }
                        >
                          <i className="material-icons">call</i>
                          <input
                            type="hidden"
                            id={"clickqueue_" + queue.queueid}
                            name={"clickqueue_" + queue.queueid}
                          />
                        </a>
                      );
                  }
                })()}
                <Popover
                  trigger="click"
                  boundary="window"
                  placement="right"
                  multiple={true}
                  interactive={true}
                  content={renderPopover(
                    this,
                    queue.caller,
                    queue.contactname,
                    queue.cdrid,
                    queue.queueid,
                    queue,
                    InfoUsers
                  )}
                >
                  <a
                    className="info tippy-context-menu"
                    data-tooltip="Mais informações"
                    data-template="info-fila"
                  >
                    <i className="material-icons">info</i>
                  </a>
                </Popover>
              </div>
            </div>

            <div
              className="title__subtop"
              onClick={(event) => checkExpandQueue(event, queue.queueid)}
            >
              {(() => {
                switch (parseInt(queue.status)) {
                  case 0:
                    return <span className="prox-atend__status">Callback</span>;
                  case 1:
                    return (
                      <span className="prox-atend__status">Fila de espera</span>
                    );
                  case 5:
                    return (
                      <span className="prox-atend__status">
                        {queue.username} está retornando
                      </span>
                    );
                  case 2:
                    return (
                      <span className="prox-atend__status">
                        {queue.username} está retornando
                      </span>
                    );
                }
              })()}
            </div>
          </div>
          <div
            className={
              buttonDetails || expandQueue.indexOf(queue.queueid) !== -1
                ? "details active"
                : "details"
            }
          >
            <div className="item details__text">
              <i className="material-icons">smartphone</i>
              {queue.caller}
            </div>
            <div className="item pct100  details__text">
              <i className="material-icons">report_problem</i> {queue.called}
            </div>
            <div className="item pct100  details__text">
              <i className="material-icons">date_range</i> {queue.to_char}
            </div>
            <div className="item pct100  details__text">
              <i className="material-icons">settings_phone</i> Qtde. de
              tentativas: <span>{queue.recv_count}</span>
            </div>
            <Popover
              interactive={true}
              boundary="window"
              placement="left"
              content={this.renderPopoverInfo2(this, queue.obs)}
            >
              <div
                className="item pct100  details__text qtd-retorno tippy-context-menu"
                data-tippy-placement="right"
                data-template="qtd-retorno"
              >
                <i className="material-icons">phone_callback</i> Qtde. de
                retorno:{" "}
                <span className="details__text-qtd">
                  {" "}
                  {queue.callback_count}
                </span>
              </div>
            </Popover>
          </div>
        </div>
      </div>
    );
  }
}

export default QueueItem;
